var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i',{class:_vm.icon,style:({ 'font-size': _vm.iconSize })})])
}
var staticRenderFns = []

export { render, staticRenderFns }